<template>
  <div class="cabinet-view-comp" v-if="data !== null" v-loading="loading">
    <div class="main">
      <div class="head" :class="OpenStatus">
        {{ data.cabinetOpenStatusName  }}
      </div>
      <div class="body" :style="{
        height: totalHeight+'px'
      }">
        <Ruler dir="left" :ruler-data="rulerData" :unit-height="unitHeight" />
        <div class="devices">
          <el-tooltip placement="top"
            v-for="(d,didx) in devicesData"
            :ref=" 'device_tooltip_' + d.snNo "
            :key="d.snNo + '_' + didx">
            <div slot="content" class="tooltip_cont">
              {{ $t('cabinetVisual.tipDeviceNo', [d.deviceNo]) }}
              <br />
              {{ $t('cabinetVisual.tipSN', [d.snNo]) }}
              <br />
              {{ $t('cabinetVisual.tipU', [d.rackUIndex]) }}
            </div>
            <a v-if="showline" href="javascript:;" :class="'deviceitem type' + d.deviceType" :style="{
                height: unitHeight * d.rackULeng + 'px',
                bottom: d.rackUStart * unitHeight + 'px'
              }">
            </a>
          </el-tooltip>
        </div>
        <Ruler dir="right" :ruler-data="rulerData" :unit-height="unitHeight" />
      </div>
      <div class="foot"></div>
    </div>
    <ul class="badge">
      <li v-for="typ in devTypes" :key="typ.label" :class="'type' + typ.num">{{ typ.label }}</li>
    </ul>
  </div>
</template>

<script>
import {
  DeviceTypes,
  CabinetOpenStatus
} from './CabinetConstants';

// 用于绘制标尺的子组件
const Ruler = {
  functional: true,
  props: {
    rulerData: Array,
    unitHeight: Number,
    dir: String
  },
  render (createElement, context) {
    const { rulerData, unitHeight, dir } = context.props;
    return createElement('ul', {
      'class': [`ruler ${dir}`],
      'style': { paddingTop: `${0.5 * unitHeight}px` }
    },
    rulerData.map(ritem => (
      createElement('li', {
        'props': { key: `${ritem.num + dir}ruler` },
        'class': { long: ritem.long },
        'style': { height: `${unitHeight}px` }
      },
      [ritem.long
        ? createElement('p', {
          'style': { marginTop: `${0.5 * (unitHeight - 20)}px` }
        },
        ritem.num)
        : null])
    )));
  } // end of render
}; // end of Ruler

// 机柜可视化主组件
export default {
  components: {
    Ruler
  },
  data() {
    return {
      loading: true
    };
  },
  props: {
    unitHeight: {
      type: Number,
      default: 10,
      required: false
    },
    data: {
      type: Object,
      default: null,
      required: true
    },
    showline: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    space () {
      return this.data.cabinetSpace;
    },
    totalHeight () {
      return this.space * this.unitHeight;
    },
    devTypes () {
      const types = [];
      for (const key in DeviceTypes) { // eslint-disable-line no-restricted-syntax
        if (Object.prototype.hasOwnProperty.call(DeviceTypes, key)) {
          const vlu = DeviceTypes[key];
          types.push({
            num: parseInt(vlu, 10),
            label: this.$t(`devicetypes.type${vlu}`)
          });
        }
      }
      types.sort((a, b) => (a.num - b.num));
      return types;
    },
    OpenStatus () {
      let openStatus = 'OpenStatusOther';
      if (this.data && ('cabinetOpenStatus' in this.data)) {
        if (this.data.cabinetOpenStatus == CabinetOpenStatus.Enabled) {
          openStatus = 'Enabled';
        } else if (this.data.cabinetOpenStatus == CabinetOpenStatus.Disabled) {
          openStatus = 'Disabled';
        }
      }
      return openStatus;
    },

    rulerData () {
      const r = [];
      for (let i = 1; i < this.space; i++) {
        r.push({
          num: i + 1,
          long: (i + 1) % 5 === 0
        });
      }
      return r.reverse();
    },
    devicesData () {
      return this.data.devices.map((dev) => {
        const [start, end] = dev.rackUIndex.split('--').map(r => parseInt(r, 10));

        return {
          snNo: dev.snNo,
          rackUIndex: dev.rackUIndex,
          rackUStart: start - 1,
          rackUEnd: end,
          rackULeng: end - start + 1,
          deviceType: dev.deviceType,
          deviceNo: dev.deviceNo
        };
      });
    }
  }, // end of computed
  mounted() {
    setTimeout(() => { // loading的最长时间
      this.loading = false;
    }, 3000);
  }
};
</script>

<style lang="scss">
@import "./cabinetVisual.scss";
</style>



// WEBPACK FOOTER //
// src/components/cabinetVisual/CabinetVisual.vue